export default {
    'crit': "Critical",
    'critdmg': "Critical Damage",
    'def': "Defense",
    'fd': "Final Damage",
    'fdlin': "Final Damage (Linear)",
};
